import React, { FC } from 'react';
import { ReactComponent as Arrow } from '../../../assets/Common/Arrow.svg';

export const ArrowIcon: FC = () => <Arrow />;
